import { scrollToSection } from "@/lib/content";
import { useT } from "@/i18n";
import Logo from "@/components/Logo";

export default function Footer({ content }) {
  const { t } = useT();
  const links = [
    { testid: "footer-link-o-nas", href: "#biuro-wirtualne-o-nas", label: t.nav.about },
    { testid: "footer-link-oferta", href: "#biuro-wirtualne-oferta", label: t.nav.offer },
    { testid: "footer-link-wiedza", href: "#biuro-wirtualne-wiedza", label: t.nav.knowledge },
    { testid: "footer-link-cennik", href: "#biuro-wirtualne-cennik", label: t.nav.pricing },
    { testid: "footer-link-kontakt", href: "#biuro-wirtualne-kontakt", label: t.nav.contact },
  ];

  return (
    <footer data-testid="footer" className="bg-slate-950 text-white border-t border-slate-800/60 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pt-16 pb-8">
        <button
          data-testid="footer-brand"
          onClick={() => scrollToSection("#biuro-wirtualne-start")}
          className="block w-full text-left font-display font-extrabold tracking-tight leading-none text-[13vw] lg:text-[9rem] text-white/10 hover:text-white/20 transition-colors duration-500 select-none"
        >
          TWOJE BIURO
        </button>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-10 text-sm">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400 font-semibold mb-4">{t.footer.nav_title}</div>
            <div className="flex flex-col gap-2.5 text-slate-400">
              {links.map((l) => (
                <button key={l.testid} data-testid={l.testid} onClick={() => scrollToSection(l.href)} className="text-left hover:text-white transition-colors duration-200 w-fit">
                  {l.label}
                </button>
              ))}
              <a data-testid="footer-link-legalizacja" href="/biuro-wirtualne-warszawa/legalizacja-dokumentow" className="text-left hover:text-white transition-colors duration-200 w-fit">
                {t.nav.legalization}
              </a>
              <a data-testid="footer-link-owu" href="/biuro-wirtualne-warszawa/owu" className="text-left hover:text-white transition-colors duration-200 w-fit">
                {t.nav.owu}
              </a>
              <a data-testid="footer-link-dokumenty" href="/biuro-wirtualne-warszawa/dokumenty" className="text-left hover:text-white transition-colors duration-200 w-fit">
                {t.footer.docs_link}
              </a>
              <a data-testid="footer-link-skrzynka" href="/biuro-wirtualne-warszawa/wyslij-podpisany-dokument" className="text-left hover:text-white transition-colors duration-200 w-fit">
                {t.footer.upload_link}
              </a>
              <a data-testid="footer-link-rodo" href="/biuro-wirtualne-warszawa/rodo" className="text-left hover:text-white transition-colors duration-200 w-fit">
                {t.nav.rodo}
              </a>
            </div>
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400 font-semibold mb-4">{t.footer.contact_title}</div>
            <div className="flex flex-col gap-2.5 text-slate-400">
              <span>{content.contact_address}</span>
              <a data-testid="footer-email-link" href={`mailto:${content.contact_email}`} className="hover:text-white transition-colors duration-200 w-fit">
                {content.contact_email}
              </a>
              <a data-testid="footer-phone-link" href={`tel:${content.contact_phone.replace(/\s/g, "")}`} className="hover:text-white transition-colors duration-200 w-fit">
                {content.contact_phone}
              </a>
              {content.contact_mobile && (
                <a data-testid="footer-mobile-link" href={`tel:${content.contact_mobile.replace(/\s/g, "")}`} className="hover:text-white transition-colors duration-200 w-fit">
                  {content.contact_mobile}
                </a>
              )}
              <span>{content.contact_hours}</span>
            </div>
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400 font-semibold mb-4">{t.footer.info_title}</div>
            <div className="flex flex-col gap-2.5 text-slate-400">
              <span>{t.footer.company}</span>
              <span>{t.footer.krs}</span>
              <span>{t.footer.license}</span>
              <span>{t.footer.insurance}</span>
              <span data-testid="footer-registry">{t.footer.registry}</span>
              <span>{t.footer.netto}</span>
            </div>
          </div>
        </div>

        <p data-testid="footer-seo" className="mt-10 text-xs leading-relaxed text-slate-500 max-w-4xl">{t.footer.seo_text}</p>
        <div className="mt-12 pt-6 border-t border-slate-800/60 flex flex-wrap items-center justify-between gap-4 text-xs text-slate-500">
          <span className="flex items-center gap-4 text-white">
            <Logo className="h-8" showTagline={false} />
            <span className="text-slate-500">{t.footer.copyright}</span>
          </span>
          <a data-testid="footer-admin-link" href="/admin" className="hover:text-white transition-colors duration-200">
            {t.footer.admin}
          </a>
        </div>
      </div>
    </footer>
  );
}
